function setCookie(name, value, days) {
  if (typeof days !== 'undefined') {
    const millisecondsInOneDay = 24 * 60 * 60 * 1000;
    const expirationDate = new Date(Date.now() + days * millisecondsInOneDay);
    const expires = `; expires=${expirationDate.toUTCString()}`;
    document.cookie = `${name}=${value}${expires}; path=/`;
  } else {
    document.cookie = `${name}=${value}; path=/`;
  }
}

function getCookie(name) {
  const nameEQ = `${name}=`;
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim();
    if (cookie.startsWith(nameEQ)) {
      return cookie.substring(nameEQ.length);
    }
  }
  return null;
}

function removeCookie(name) {
  setCookie(name, "", { days: -1 }); 
}

export { setCookie, getCookie, removeCookie };
